import auth0 from 'auth0-js';
export const webAuth = new auth0.WebAuth({
  domain: process.env.REACT_APP_AUTH0_AUTH_DOMAIN,
  clientID: process.env.REACT_APP_AUTH0_CLIENT_ID,
  redirectUri: window.location.origin + '/callback',
  responseType: 'token id_token',
  scope: 'openid profile email phone',
  audience: `https://${process.env.REACT_APP_AUTH0_DOMAIN}/api/v2/`
});
